export const EMPLOYEES_TABLE_COLUMNS = 7
